import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { BarcodeScanner } from '@ionic-native/barcode-scanner';
// import { BrowserQRCodeReader } from '@zxing/library';
// import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
import { WithdrawalcoinlistPage } from '../withdrawalcoinlist/withdrawalcoinlist';
// import { WithdrawalPage } from '../withdrawal/withdrawal';
import { WithdrawalconfirmPage } from '../withdrawalconfirm/withdrawalconfirm';

/**
 * Generated class for the WithdrawalcoinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-withdrawalcoin',
	templateUrl: 'withdrawalcoin.html',
})
export class WithdrawalcoinPage {

	loginId: string;
	api_key: string;
	version: string;

    from: string;
    target_coin: string;
	// wallet_address: string;
	// bank: string;
	// bank_list: any = [];
	// account_holder: string;
	address: string;
	balance: any = [];
	min: string = '0';
	max: string = '0';
    remain: string;
	txid: string;
	fee_amount: string;
	fee: string;
	// donation: string;
	rate: string;

	parts: any;
	value: string = '0';
    symbol: string;
    coin_unit: string;
    bonus_unit: string;
    usdt_name: string;
    unit: string;
	// target_wallet_address: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;
    isToken : boolean = false;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
		) {
			// this.target_wallet_address = "";
			this.value = "";
            this.from = navParams.get("from");
            this.target_coin = navParams.get("target_coin");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoin");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.usdt_name = localStorage.getItem("usdt_name");
        this.unit = localStorage.getItem("unit");
        
		// this._init_bank();
        if (this.target_coin == 'token') {
            this.isToken = true; 
            // this.coin_unit = this.unit
        }
		this._init();
        
        this._get_texts();       

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawalcoin;
	}

    keyDown(event) {
        if (this.value == undefined || this.value == null) {
			var tmps: string = "";
		} else {
			let pattern = /^\d*[.]\d*$/; 
            var tmps = this.value.replace(/[^0-9.]/g, "");
            if (pattern.test(tmps)) {
                if (event.keyCode == 110 || event.keyCode == 190) {
                        return false;
                }
            }
		}
		
		// this.value = tmps.replace(/[^0-9]/g, "");
    }

    keyUp() {
        if(this.value != null || this.value != "") {
            var tmps = this.value.replace(/[^0-9.]/g, "");    
			var parts: any = tmps.toString().split(".");
			var floats: any = tmps.toString().indexOf(".");
			// var tron = Number(this.balance.replace(/[^0-9.]/g, ""));

			if(floats == -1){
                if(parts[0].length > 20) parts[0] = parts[0].substr(0, 20);
                parts[0] = parts[0] * 1;                         
			    if(parts[0] == 0) parts[0] = '0';

                parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
                this.value = parts[0];
				// if (parts[0] > tron) {
				// 	this.value = this.balance;
					
				// } else {
				// 	parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
				// 	this.value = parts[0];
				// }
			}else{
				if(parts[0].length > 13) parts[0] = parts[0].substr(0, 13);
				if(parts[1].length > 2) parts[1] = parts[1].substr(0, 2);
                var tmp1 = Number(parts.join("."));

                parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.value = parts.join(".");
				// if (tmp1 > tron) {
				// 	this.value = this.balance;
					
				// } else {
				// 	parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                // 	this.value = parts.join(".");
				// }
			}
        }
        
	}
    
    // floor() {
    //     let url = "withdraw/base/index/floor";
    //     let send_data = JSON.stringify({ 
    //         api: this.api_key,
	// 		language: this.language,
	// 		version: this.version,
	// 		value: this.value
    //     });
        
    //     this.http.post_floor(url, send_data).then((res: any) => {
    //         if(res.result == "OK"){
    //             // this.balance = res.balance;
	// 			this.remain = res.remain;
	// 			this.value = res.value;
	// 			this.fee_amount = res.fee;
	// 			// this.ether = res.ether;

    //         } else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		}else{

    //         } 
    //     },(err)=>{	
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
		
	// 	});
    // }

	onSend(){
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

		this.isSend = false;

        // if (!this.bank || this.bank.length == 0) {
		// 	const toast = this.toastCtrl.create({
		// 		message:  this.texts.toastM_bank,
		// 		duration: 2000,
		// 		position: 'middle'
		// 	});
        //     toast.present();
        //     this.isSend = true;
		// 	return false;
		// }

		if (!this.address || this.address.length == 0) {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_wallet,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

		if (!this.value || this.value.length == 0 || this.value =="0") {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_amount,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

        let modal = this.modalCtrl.create(WithdrawalconfirmPage, {target_coin: this.target_coin, address: this.address, value: this.value});
        modal.present();
        modal.onDidDismiss( data => {
            if (data != '') {
                this.isSend = true;
                this.navCtrl.pop();
                this.navCtrl.pop();
                this.navCtrl.push(WithdrawalcoinlistPage, {segment : 'pending', target_coin : data});

                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_completed,
                    buttons: ['OK']
                });
                alert.present();


                this._init();

            } else {
                this.isSend = true;
                this._init();
            }
        });

        
	}

    _init() {
		//// 서버로부터의 데이타
        let url
        if (this.isToken) {
            url = "withdraw/binance/token";
        } else {
            url = "withdraw/binance";
        }
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				this.address = res.address;
				// this.account_holder = res.account_holder;
				// this.remain = res.remain;
				this.balance = res.balance;
				this.symbol = res.symbol;
				this.coin_unit = res.coin_unit;
				this.bonus_unit = res.bonus_unit;
				this.min = res.min;
				this.max = res.max;
				this.fee = res.fee;
				// this.donation = res.donation;
				this.rate = res.rate;
				
				// this.floor();
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

    // _init_bank() {
    //     let url = "common/bank";
    //     let body = JSON.stringify({
    //         language: this.language
    //     });
    //     this.http.post(url, body).then((res:any)=>{
    //         if(res.result=="OK"){
    //             this.bank_list = res.bank;

    //         } else if(res.result ==="LOGOUT"){
    //             let alert = this.alertCtrl.create({
    //                 message: res.message,
    //                 buttons: ['OK']
    //             });
    //             alert.present();
    //             localStorage.removeItem("loginId");
    //             this.app.getRootNav().setRoot(LoginPage);
            
    //         } else {
    //             let alert = this.alertCtrl.create({
    //                 message: res.message,
    //                 buttons: ['OK']
    //             });
    //             alert.present();
    //         }
    //     },(err)=>{
    //         let alert = this.alertCtrl.create({
    //             message: this.texts.alertM_err,
    //             buttons: ['OK']
    //         });
    //         alert.present();
    //     });
    // }
	
	onTlist() {
        if (this.from == 'list') {
            this.navCtrl.pop();

        } else {
            this.navCtrl.push(WithdrawalcoinlistPage);

        }
	}


}



// WEBPACK FOOTER //
// ./src/pages/withdrawalcoin/withdrawalcoin.ts